module.exports = __webpack_public_path__ + "static/img/hero-banner-replacement-ver5.cfd36b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero-banner-replacement-ver5.png
// module id = 112w
// module chunks = 62